/* unplugin-vue-components disabled */import script from "./ProductPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPicker.vue?vue&type=script&setup=true&lang=js"

import "./ProductPicker.vue?vue&type=style&index=0&id=423b5f53&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423b5f53"]])

export default __exports__